import { createTheme } from "@mui/material/styles";

const defaultTheme = createTheme();

export const typography = {
  fontFamily: "Inter, Roboto, Helvetica, Arial, sans-serif",
  h1: {
    fontSize: defaultTheme.typography.pxToRem(48),
    fontWeight: 700,
    lineHeight: 1.15,
    letterSpacing: 0,
  },
  h2: {
    fontSize: defaultTheme.typography.pxToRem(36),
    fontWeight: 700,
    lineHeight: 1.2,
    letterSpacing: 0,
  },
  h3: {
    fontSize: defaultTheme.typography.pxToRem(30),
    fontWeight: 700,
    lineHeight: 1.25,
    letterSpacing: 0,
  },
  h4: {
    fontSize: defaultTheme.typography.pxToRem(24),
    fontWeight: 700,
    lineHeight: 1.35,
    letterSpacing: 0,
  },
  h5: {
    fontSize: defaultTheme.typography.pxToRem(20),
    fontWeight: 700,
    lineHeight: 1.4,
    letterSpacing: 0,
  },
  h6: {
    fontSize: defaultTheme.typography.pxToRem(18),
    fontWeight: 700,
    lineHeight: 1.45,
    letterSpacing: 0,
  },
  subtitle1: {
    fontSize: defaultTheme.typography.pxToRem(16),
    fontWeight: 600,
    lineHeight: 1.5,
    letterSpacing: 0,
  },
  subtitle2: {
    fontSize: defaultTheme.typography.pxToRem(14),
    fontWeight: 600,
    lineHeight: 1.45,
    letterSpacing: 0,
  },
  body1: {
    fontSize: defaultTheme.typography.pxToRem(14),
    lineHeight: 1.5,
    letterSpacing: 0,
  },
  body2: {
    fontSize: defaultTheme.typography.pxToRem(14),
    lineHeight: 1.45,
    letterSpacing: 0,
  },
  button: {
    fontWeight: 600,
    letterSpacing: 0,
    textTransform: "none",
  },
  caption: {
    fontSize: defaultTheme.typography.pxToRem(12),
    lineHeight: 1.35,
    letterSpacing: 0,
  },
};
